module.exports = __webpack_public_path__ + "img/MDI-download-outline.0b95c84d.svg";